import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import PostPurchaseAnalyticsMiddleware from './PostPurchaseAnalyticsMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    PostPurchaseAnalyticsMiddleware,
    AccountComponentsMiddleware,
];

export default rootMiddleware;
